import { Link } from 'react-router-dom';
import './Style/Home.css';
import TopNavbar from './TopNavbar';
import StudyOption from '../AllData/HomeData';
import { useTrackUser } from '../Component/useTrackUser';
import { usePreventBackButton } from '../Component/usePreventBackButton';
import { ItemClick } from '../Component/ItemClick';
import useUsersData from '../Auth/AllUsers';
import { OnlineStatus } from '../Component/OnlineStatus';


function Home() {
  const studyOptions = StudyOption;
  const activeOptions = studyOptions.filter(option => option.status === "true");
  const { users, loading } = useUsersData();
  const userPhone = localStorage.getItem('userPhone');

  const isOnline = OnlineStatus();

  const targetUser = users.find(user => user.phone === userPhone);
  const userName = targetUser?.name;
  const userEmail = targetUser?.email;
  const userClass = targetUser?.class;
  const registerDate = targetUser?.registar_date;
  const lastLogin = targetUser?.last_login;

  if (isOnline) {

    if (userPhone && !loading) {
      localStorage.setItem('userPhone', userPhone);
      localStorage.setItem('userEmail', userEmail);
      localStorage.setItem('userName', userName);
      localStorage.setItem('userClass', userClass);
      localStorage.setItem('registerDate', registerDate);
      localStorage.setItem('lastLogin', lastLogin);
    }
  }

  const currentUserId = localStorage.getItem('userId');
  const name = userName || "to JEE Prep App";

  usePreventBackButton();
  useTrackUser();

  return (
    <div className="study-app">

      <TopNavbar name={name} />

      <header className="app-header">
        <h1>🎯 JEE → 🎓 Engineering</h1>
      </header>

      <br></br>


      <div className="study-grid">
        {activeOptions.map((option) => {

          return (
            <Link
              to={option.link}
              key={option.id}
              className="study-card-link"
              onClick={() => ItemClick(option, userPhone, currentUserId)}
            >
              <div
                className="study-card"
                style={{ position: 'relative' }}
              >
                <div className="card-row">
                  <div className="card-icon">
                    <span style={{ fontSize: '70px', lineHeight: 1 }}>
                      {option.symbol}
                    </span>
                  </div>
                  <h3>{option.name} →</h3>
                </div>

              </div>
            </Link>
          );
        })}
      </div>

      <br></br><br></br>

    </div>
  );
}

export default Home;